// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

// eslint-disable-next-line spire/fenced-imports
import { hideAll } from "tippy.js";

import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { getPageLinkByPageType } from "@insite/client-framework/Store/Links/LinksSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { Link } from "@insite/mobius/index";
import { LinkPresentationProps } from "@insite/mobius/Link";
import { CustomAppState } from "@rc/App/Store/Reducers";
import * as cssLinter from "css";
import * as React from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

const mapStateToProps = (state: CustomAppState) => {
    return {
        rcAcademyPageUrl: getPageLinkByPageType(state, "RcAcademyPage")?.url,
    };
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.customCSS]?: string;
        [fields.rcAcademyLinkTitle]?: string;
    };
}

type Props = OwnProps & ReturnType<typeof mapStateToProps>;

const enum fields {
    customCSS = "customCSS",
    rcAcademyLinkTitle = "rcAcademyLinkTitle",
}

const defaultCustomCss = `&{ }`;

export interface RcAcademyStyles {
}

export const rcAcademyStyles: RcAcademyStyles = {
}

const styles = rcAcademyStyles;

const RcAdademy: React.FunctionComponent<Props> = (props: Props) => {
    const {
        fields: {
            customCSS,
            rcAcademyLinkTitle,
        },
        rcAcademyPageUrl,
    } = props;
    const hideTippy = () => {
        setTimeout(() => {
            hideAll();
        }, 500);
    };


    return (
        <StyledWrapper
            css={
                css`${customCSS}`
            }>
            <Link
                href={rcAcademyPageUrl}
                onClick={hideTippy}
            >
                {rcAcademyLinkTitle || translate("RC Academy Vet")}
            </Link>
        </StyledWrapper>
    );

};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, null)(RcAdademy),
    definition: {
        group: "XNGAGE" as any,
        displayName: "RC Academy",
        fieldDefinitions: [
            {
                name: fields.customCSS,
                displayName: "Custom CSS",
                editorTemplate: "CodeField",
                fieldType: "General",
                defaultValue: defaultCustomCss,
                validate: value => {
                    if (value === undefined || value === null) {
                        return "";
                    }
                    const result = cssLinter.parse(value, { silent: true });
                    if (result?.stylesheet?.parsingErrors) {
                        // the error output at this time only has room for one line so we just show the first error
                        return result.stylesheet.parsingErrors.length <= 0
                            ? ""
                            : result.stylesheet.parsingErrors.map(error => `${error.reason} on line ${error.line}`)[0];
                    }
                    return "Unable to parse Css";
                },
                options: {
                    mode: "css",
                    lint: true,
                    autoRefresh: true,
                },
            },
            {
                name: fields.rcAcademyLinkTitle,
                editorTemplate: "TextField",
                defaultValue: "RC Academy",
                fieldType: "General",
            },
        ],
    },
};

export default widgetModule;
